import asyncThunk from '@/lib/asyncThunk'
import { LoggingDestination } from '@/out/logging'

type Request = {
  destination: LoggingDestination
}

export const deleteLogging = asyncThunk<Request, void>({
  name: 'logging/delete',
  method: 'DELETE',
  uri: '/logging',
})
